import React, { useState, useEffect, useContext } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
  Container,
  Typography,
} from '@material-ui/core';

import LanguageContext from "../contexts/LanguageContext"
import { logout } from "../utils/auth"

const NoAccess = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [timer, setTimer] = useState(20);
  const [toggle, setToggle] = useState(true);


  useEffect(() => {
    let counter;
    if (toggle) {
      counter = setInterval(() => setTimer(timer => timer - 1), 1000);
    }
    return () => {
      clearInterval(counter);
    };
  }, [toggle]);

  useEffect(() => {
    if (timer === 0) {
      setToggle(false);
      logout(() => navigate("/"))
    }
  }, [timer])



  return (
    <>
      <Helmet>
        <title>{languageValues?.error[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Box sx={{ mb: 2, textAlign:"center" }}>
            <Typography
              color="text.blackTitle"
              variant="h2"
            >
              {languageValues?.noAccess?.title[actLanguage]}
            </Typography>
          </Box>
          <Box
            sx={{
              fontSize:"18px",
              color:"text.black",
              textAlign:"center",
              marginBottom:"15px",
              whiteSpace:"pre-wrap",
            }}
          >
            {languageValues?.noAccess?.texte[actLanguage]}
          </Box>
          <Box sx={{ py: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                logout(() => navigate("/"))
              }}
            >
              {languageValues?.noAccess?.button[actLanguage]} ({timer})
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NoAccess;
